import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'
import { createPortal } from 'react-dom'

export const ModalContainerContext = createContext<HTMLDivElement | null>(null)

/**
 * Creates a portal to the modal container provided by context.
 * @param children
 * @returns
 */
export const ModalContainerPortal: FC<PropsWithChildren> = ({ children }) => {
  const container = useContext(ModalContainerContext)
  if (!container) {
    throw new Error('Modal container is not provided in the context')
  }

  return createPortal(children, container)
}
